module.exports = __webpack_public_path__ + "assets/img/1ef8-mn.svg";